module.exports = __webpack_public_path__ + "img/S_LOGO_MOBI_ANIMATION.3d00d831.svg";